const elements = {
  navigation: document.body.querySelector('.js-navigation-alt'),
  panel: document.body.querySelector('.js-navigation-alt-panel'),
  trigger: document.body.querySelector('.js-navigation-alt-trigger'),
  dropdowns: document.body.querySelectorAll('.js-navigation-alt-dropdown')
};
const active = 'is-active';

function init() {
  if (elements.navigation !== null) {
    elements.trigger.addEventListener('click', () => {
      elements.trigger.classList.toggle(active);
      elements.panel.classList.toggle(active);
      document.body.classList.toggle('nav-is-active');
    });

    if (elements.dropdowns.length > 0) {
      elements.dropdowns.forEach((dropdown) => dropdown.addEventListener('click', () => {
        dropdown.parentElement.classList.toggle('dropdown-is-active');
      }))
    }
  }
}

export default init;



// WEBPACK FOOTER //
// ./src/components/components/entrade/navigation/navigation.js